
import { useEffect, useState } from 'react';

export function QuantityStepper({ value, max, label, onChange, disabled = false }) {
  const [draft, setDraft] = useState(String(value));


  useEffect(() => setDraft(String(value)), [value]);

  const clamp = (next) => Math.max(1, Math.min(max, next));

  const commit = async (next) => {
    const clamped = clamp(next);

    setDraft(String(clamped));

    if (clamped === value) return;

    const result = await onChange(clamped);
    if (!result?.success) setDraft(String(value));
  };

  return (
    <div className="qty-stepper" role="group" aria-label={label}>
      <button
        type="button"
        className="qty-btn"
        aria-label="Decrease quantity"
        disabled={disabled || value <= 1}
        onClick={() => commit(value - 1)}
      >
        <i className="fa-solid fa-minus" />
      </button>

      <input
        type="text"
        inputMode="numeric"
        className="qty-value"
        aria-label={label}
        value={draft}
        disabled={disabled}
        onChange={(event) => setDraft(event.target.value.replace(/[^0-9]/g, ''))}
        onBlur={() => commit(Number(draft) || 1)}
        onKeyDown={(event) => event.key === 'Enter' && event.currentTarget.blur()}
      />

      <button
        type="button"
        className="qty-btn"
        aria-label="Increase quantity"
        disabled={disabled || value >= max}
        onClick={() => commit(value + 1)}
      >
        <i className="fa-solid fa-plus" />
      </button>
    </div>
  );
}
